/* eslint-disable */
import dayjs from "dayjs";
import { toastr } from "react-redux-toastr";
import { hideLoader, showLoader, verifyQualificationDigilocker } from "../../common/actions/commonActions";
import {
  ADD_EXPERIENCEINFO,
  ADD_INTERNSHIP,
  ADD_INTERNSHIP_LIST,
  ADD_QUALIFICATION,
  CLEAR_SPORT_DTO,
  EDIT_EXPERIENCEINFO,
  EDIT_INTERNSHIP,
  EDIT_QUALIFICATION,
  EDIT_QUALIFICATION_DONE_RESET,
  EDIT_SPORT_DETAILS_LIST,
  GET_ALL_JOB_DESIGNATION_LIST,
  GET_NAME_OF_INDEXING_BODIES,
  GET_TYPE_OF_ARTICLES,
  IS_QUALIFICATION_TYPE_CHANGED_BY_DROPDOWN,
  SET_ADDITIONAL_RES_ENV_DATA,
  SET_ADDRESS_INFO,
  SET_ALL_DISABILITIES_DATA,
  SET_A_SUBMITTABLE_FLG,
  SET_BUTTONS_VISIBLE,
  SET_CROPE_IMAGE_SRC,
  SET_CROPE_LIVEIMAGE_SRC,
  SET_CROP_SIGNATURE_SRC,
  SET_CURRENT_EDIT_INTERNSHIP_INDEX,
  SET_CURRENT_EDIT_QUALIFICATION_INDEX,
  SET_DIGILOCKER_ACCESSTOKEN_DATA,
  SET_DISABLE_ALL_TAB_SAVE,
  SET_DISPLAYABLE_QUALIFICATION_LIST,
  SET_DISTRICTS,
  SET_DISTRICTS_CORRESPONDENCE,
  SET_EDIT_INDEX,
  SET_EXPERIENCEINFO_EDIT_FLAG,
  SET_EXPERIENCE_INFO,
  SET_EXPERIENCE_TABLE_LIST,
  SET_HINDI_SIGNATURE_SRC,
  SET_IMAGE_SIGNATURE_FLAG,
  SET_IMAGE_SRC,
  SET_INTERNSHIP_INFORMATION,
  SET_INTERNSHIP_LIST,
  SET_ISSUING_DISTRICTS,
  SET_IS_EDITING,
  SET_IS_LIVE_PHOTO_VALIDATE_VALUE,
  SET_LIVEIMAGE_SRC,
  SET_OTHER_INFORMATION,
  SET_PERSONAL_DIGILOCKER_STATUS,
  SET_PERSONAL_INFO,
  SET_PROFILE_CREATION_LOOKUPS,
  SET_PROFILE_STATUS,
  SET_PUBLICATION_TYPE_DATA,
  SET_QUALIFICATION_INFORMATION,
  SET_QUALIFICATION_NAMES,
  SET_QUALIFICATION_TYPES,
  SET_SELECTED_QUALIFICATION_TYPE,
  SET_SHOW_MODAL_VALUE,
  SET_SIGNATURE_SRC,
  SET_SPORT_DETAILS_LIST,
  SET_STATES,
  SET_SUBJECTS,
  SET_TALUKAS,
  SET_TALUKAS_CORRESPONDENCE,
  SET_TOGGLE_EDIT_MODE,
  SET_UNIVERSITIES,
  SET_UPDATE_PROFILE_DONE,
  SET_UPLOADED_PHOTO,
  SET_VILLAGES,
  SET_VILLAGES_CORRESPONDENCE
} from "../../common/constants/ActionTypes";
import {
  ADDRESS_INFORMATION,
  DISTRICTS,
  EXPERIENCE_INFORMATION,
  GET_ADDITIONAL_RES_ENV,
  GET_DIGILOCKER_VERIFY_DETAILS,
  GET_DISPLAYABLE_QUALIFICATION_LIST,
  GET_PERSONAL_DIGILOCKER_STATUS,
  GET_PUBLICATION_TYPE_DATA,
  INTERNSHIP,
  LIVE_PHOTO_DRAFT_API,
  LOOKUP_OPTION,
  LOOKUP_OPTIONS,
  OTHER_INFORMATION,
  PHOTO_URL,
  PROFILE,
  PROFILE_CREATION,
  QUALIFICATION_INFORMATION,
  QUALIFICATION_NAME,
  QUALIFICATION_TYPES,
  STATES,
  SUBJECTS,
  TALUKAS,
  UNIVERSITIES,
  VILLAGES
} from "../../common/constants/endpoints";
import commonENLabels from "../../common/labels/common_en.json";
import API from "../../helpers/API";
import { dateDifferece } from "../../helpers/Datetime";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/profile.css";
import { experienceInfoReqDTO } from "../constants/experienceInfoReqDTO";
import { mandatoryEducation } from "../constants/QualificationConstants";
import qualificationinformation from "../labels/qualification_information_en.json";

const processAddressInfoResponse = (response, dispatch) => {
  if (response && response.data) {
    let addressInformationResponse = {
      permenantAddressState: {
        permenantHouseNo: response.data.permenantAddressLine1,
        permenantBuildingName: response.data.permenantAddressLine2,
        permenantRoadOrPo: response.data.permenantAddressLine3,
        permenantState: response.data.permenantStateId,
        permenantDistrict: response.data.permenantDistrictId,
        permenantTaluka: response.data.permenantTalukaId,
        permenantVillageCity: response.data.permenantVillageCityId,
        permenantDistrict1: response.data.permenantDistrict,
        permenantTaluka1: response.data.permenantTaluka,
        permenantVillageCity1: response.data.permenantVillageCity,
        permenantPin: response.data.permenantPin,
        updatedAt: response.data.updatedAt,
        isLocked: response.data.isLocked,


      },
      correspondenceAddressState: {
        correspondenceHouseNo: response.data.correspondenceAddressLine1,
        correspondenceBuildingName: response.data.correspondenceAddressLine2,
        correspondenceRoadOrPo: response.data.correspondenceAddressLine3,
        correspondenceState: response.data.correspondenceStateId,
        correspondenceDistrict: response.data.correspondenceDistrictId,
        correspondenceTaluka: response.data.correspondenceTalukaId,
        correspondenceVillageCity: response.data.correspondenceVillageCityId,
        correspondenceDistrict1: response.data.correspondenceDistrict,
        correspondenceTaluka1: response.data.correspondenceTaluka,
        correspondenceVillageCity1: response.data.correspondenceVillageCity,
        correspondencePin: response.data.correspondencePin,
        updatedAt: response.data.updatedAt,
      },
      isSameAsAbove: response.data.isSame,
    };
    dispatch({
      payload: addressInformationResponse,
      type: SET_ADDRESS_INFO,
    });
    dispatch({
      payload: { addressInfo: response.data.isSubmittable },
      type: SET_A_SUBMITTABLE_FLG,
    });
  }
};

const processQualificationInfoResponse = (response, dispatch) => {
  if (response && response.data) {
    let qualificationInformationResponse = response.data;

    dispatch({
      payload: qualificationInformationResponse,
      type: SET_QUALIFICATION_INFORMATION,
    });

    let updatedFlgSubmittable =
      response.data.length > 0
        ? response.data.every((elem) => elem.isSubmittable)
        : false;

    dispatch({
      payload: { qualificationInfo: updatedFlgSubmittable },
      type: SET_A_SUBMITTABLE_FLG,
    });
  }
};


const processInternshipInfoResponse = (response, dispatch) => {
  if (response && response.data) {
    let internshipInfoResponse = response.data;

    dispatch({
      payload: internshipInfoResponse,
      type: SET_INTERNSHIP_INFORMATION,
    });

    let updatedFlgSubmittable =
      response.data.length > 0
        ? response.data.every((elem) => elem.isSubmittable)
        : false;

    dispatch({
      payload: { internshipInfo: updatedFlgSubmittable },
      type: SET_A_SUBMITTABLE_FLG,
    });
  }
};

//  To enable currennt row and disable all other row for editing
export const toggleAndSetEditing = (index, isEditing, buttons) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_IS_EDITING,
        payload: isEditing,
      });

      dispatch({
        type: SET_EDIT_INDEX,
        payload: index,
      });
      dispatch({
        type: SET_BUTTONS_VISIBLE,
        payload: buttons,
      });
    } catch (error) {
      console.error("Error in toggleAndSetEditing action:", error);
    }
  };
};

const processExperienceInfoResponse = (response, dispatch) => {

  if (response && response.data) {
    let experienceResponseList = response.data;

    let experienceInformationResponse = [];
    for (let i = 0; i < experienceResponseList.length; i++) {
      if (!experienceResponseList[i].isExperience) {
        continue;
      }
      let employmentFromDate = experienceResponseList[i].employmentFrom
        ? dayjs(experienceResponseList[i].employmentFrom).toDate()
        : new Date();
      let employmentToDate = experienceResponseList[i].employmentTo
        ? dayjs(experienceResponseList[i].employmentTo).toDate()
        : "";
      let appointmentLetterDate = experienceResponseList[i]
        .appointmentLetterDate
        ? dayjs(experienceResponseList[i].appointmentLetterDate).toDate()
        : "";
      experienceInformationResponse.push({
        typeEmploymentLookupId:
          experienceResponseList[i].typeEmploymentLookupId,
        employeeTypeLookupId: experienceResponseList[i].employeeTypeLookupId,
        // isBpscSelection: experienceResponseList[i].isBpscSelection,
        institutionLookupId: experienceResponseList[i].institutionLookupId,
        postNameLookupId: experienceResponseList[i].postNameLookupId,
        postNameOther: experienceResponseList[i].postNameOther,
        officeName: experienceResponseList[i].officeName,
        isOfficeGovOwned: experienceResponseList[i].isOfficeGovOwned,
        designation: experienceResponseList[i].designation,
        designationId: experienceResponseList[i].designationId,
        jobNatureLookupId: experienceResponseList[i].jobNatureLookupId,
        isGazettedPost: experienceResponseList[i].isGazettedPost,
        typeGroupLookupId: experienceResponseList[i].typeGroupLookupId,
        apointmentNatureLookupId:
          experienceResponseList[i].apointmentNatureLookupId,
        fullTimeLookupId: experienceResponseList[i].fullTimeLookupId,
        appointmentLetterNo: experienceResponseList[i].appointmentLetterNo,
        appointmentLetterDate: appointmentLetterDate,
        payScale: experienceResponseList[i].payScale,
        gradePay: experienceResponseList[i].gradePay,
        basicPay: experienceResponseList[i].basicPay,
        monthlyGrossSalary: experienceResponseList[i].monthlyGrossSalary,
        employmentFrom: employmentFromDate,
        employmentTo: employmentToDate,
        expYears: experienceResponseList[i].expYears,
        expMonths: experienceResponseList[i].expMonths,
        expDays: experienceResponseList[i].expDays,
        remarks: experienceResponseList[i].remarks,
        id: experienceResponseList[i].id,
        isDeleted: experienceResponseList[i].isDeleted,
        isLocked: experienceResponseList[i].isLocked,
        isSubmittable: experienceResponseList[i].isSubmittable,
        isExperience: experienceResponseList[i].isExperience,
        updatedAt: experienceResponseList[i].updatedAt,
      });
    }
    dispatch({
      payload: experienceInformationResponse,
      type: SET_EXPERIENCE_INFO,
    });
    let updatedFlgSubmittable =
      response.data.length > 0
        ? response.data.every((elem) => elem.isSubmittable)
        : false;
    dispatch({
      payload: { experienceInfo: updatedFlgSubmittable },
      type: SET_A_SUBMITTABLE_FLG,
    });
  }
};

export const addressAction = (newaddressDetails) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let userId = session.userId;
      let request = {
        permenantAddressLine1: newaddressDetails.permenantHouseNo && newaddressDetails.permenantHouseNo.toUpperCase(),
        permenantAddressLine2: newaddressDetails.permenantBuildingName && newaddressDetails.permenantBuildingName.toUpperCase(),
        permenantAddressLine3: newaddressDetails.permenantRoadOrPo && newaddressDetails.permenantRoadOrPo.toUpperCase(),
        permenantStateId: newaddressDetails.permenantState,
        permenantDistrictId: newaddressDetails.permenantDistrict,
        permenantDistrict: newaddressDetails.permenantDistrict1 && newaddressDetails.permenantDistrict1.toUpperCase(),
        permenantTalukaId: newaddressDetails.permenantTaluka,
        permenantTaluka: newaddressDetails.permenantTaluka1 && newaddressDetails.permenantTaluka1.toUpperCase(),
        permenantVillageCityId: newaddressDetails.permenantVillageCity,
        permenantVillageCity: newaddressDetails.permenantVillageCity1 && newaddressDetails.permenantVillageCity1.toUpperCase(),
        permenantPin: newaddressDetails.permenantPin,
        correspondenceAddressLine1: newaddressDetails.correspondenceHouseNo && newaddressDetails.correspondenceHouseNo.toUpperCase(),
        correspondenceAddressLine2:
          newaddressDetails.correspondenceBuildingName && newaddressDetails.correspondenceBuildingName.toUpperCase(),
        correspondenceAddressLine3: newaddressDetails.correspondenceRoadOrPo && newaddressDetails.correspondenceRoadOrPo.toUpperCase(),
        correspondenceStateId: newaddressDetails.correspondenceState,
        correspondenceDistrictId: newaddressDetails.correspondenceDistrict,
        correspondenceTalukaId: newaddressDetails.correspondenceTaluka,
        correspondenceVillageCityId:
          newaddressDetails.correspondenceVillageCity,
        correspondenceDistrict: newaddressDetails.correspondenceDistrict1 && newaddressDetails.correspondenceDistrict1.toUpperCase(),
        correspondenceTaluka: newaddressDetails.correspondenceTaluka1 && newaddressDetails.correspondenceTaluka1.toUpperCase(),
        correspondenceVillageCity: newaddressDetails.correspondenceVillageCity1 && newaddressDetails.correspondenceVillageCity1.toUpperCase(),
        correspondencePin: newaddressDetails.correspondencePin,
        profileId: profileId,
        userId: userId,
        isSubmittable: 1,
        isSame: newaddressDetails.isSameAsAbove ? newaddressDetails.isSameAsAbove : false,
      };
      if (
        parseInt(request.permenantStateId) ===
        commonENLabels.DATABASE_VALUES.STATE_CODE
      ) {
        request.permenantDistrict = newaddressDetails.permenantDistrict1
          ? newaddressDetails.permenantDistrict1.toUpperCase()
          : "";
        request.permenantTaluka = newaddressDetails.permenantTaluka1
          ? newaddressDetails.permenantTaluka1.toUpperCase()
          : "";
        request.permenantVillageCity = newaddressDetails.permenantVillageCity1
          ? newaddressDetails.permenantVillageCity1.toUpperCase()
          : "";
      } else {
        request.permenantDistrictId = null;
        request.permenantTalukaId = null;
        request.permenantVillageCityId = null;
      }
      if (
        parseInt(request.correspondenceStateId) ===
        commonENLabels.DATABASE_VALUES.STATE_CODE
      ) {
        request.correspondenceDistrict =
          newaddressDetails.correspondenceDistrict1
            ? newaddressDetails.correspondenceDistrict1.toUpperCase()
            : "";
        request.correspondenceTaluka = newaddressDetails.correspondenceTaluka1
          ? newaddressDetails.correspondenceTaluka1.toUpperCase()
          : "";
        request.correspondenceVillageCity =
          newaddressDetails.correspondenceVillageCity1
            ? newaddressDetails.correspondenceVillageCity1.toUpperCase()
            : "";
      } else {
        request.correspondenceDistrictId = null;
        request.correspondenceTalukaId = null;
        request.correspondenceVillageCityId = null;
      }
      let response;
      let isFirstPost = false;
      if (profileId) {
        let getResponse = await API.get(ADDRESS_INFORMATION + `/${profileId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (getResponse && getResponse.data) {
          response = await API.patch(ADDRESS_INFORMATION, request, {
            headers: { Authorization: `Bearer ${token}` },
          });
        } else {
          isFirstPost = true;
        }
        if (getResponse != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
        isFirstPost = true;
      }
      if (isFirstPost) {
        response = await API.post(ADDRESS_INFORMATION, request, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response && response.data) {
          const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
          session.profileId = response.data.profileId;
          sessionStorage.setItem("session", JSON.stringify(session));
        }
        if (response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      if (response) {
        toastr.success(commonLabels.ADD_SAVE_NOTE);
        window.scrollTo(0, 0);
        processAddressInfoResponse(response, dispatch);
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }
    }
  };
};

export const addExperienceList = (experienceInfoToBeAdded, experiencesList) => {

  if (!experienceInfoToBeAdded.jobNatureLookupId) {
    toastr.warning("Please add a job Nature at 5.6")
    return;
  }

  return async (dispatch) => {
    try {
      dispatch({
        type: ADD_EXPERIENCEINFO,
        payload: [...experiencesList, experienceInfoToBeAdded],
      });

      toastr.info(commonLabels.REC_ADD_NOTE);
    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_ADDING_EXP_DETAILS, errorMessage);
    }
  };
};

export const editExperienceInfo = (
  experienceToBeEdited,
  existingexperiencesList
) => {

  if (!experienceToBeEdited.designationId) {
    toastr.warning("Please select designation from 5.5")
    return;
  }
  if (!experienceToBeEdited.jobNatureLookupId) {
    toastr.warning("Please add a job Nature from 5.6")
    return;
  }
  return async (dispatch) => {
    try {
      let editIndex = existingexperiencesList.findIndex((ele) => {
        return ele.id === experienceToBeEdited.id;
      });
      if (editIndex !== -1) {
        existingexperiencesList[editIndex] = experienceToBeEdited;
        toastr.info(commonLabels.REC_UPDATED_NOTE);
        dispatch({
          type: SET_EXPERIENCEINFO_EDIT_FLAG,
          payload: false,
        });
        dispatch({
          type: ADD_EXPERIENCEINFO,
          payload: existingexperiencesList,
        });
      }
    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_EDITING_QUA_DETAILS, errorMessage);
    }
  };
};

export const saveExperienceList = (experiencesList, isExperience) => {


  // for (let i = 0; i < experiencesList.length; i++) {
  //   if (!experiencesList[i].jobNatureLookupId) {
  //     toastr.warning("Please select job nature from");
  //     return;
  //   }
  // }

  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (isExperience === "Yes" && experiencesList.length === 0) {
        dispatch(hideLoader());
        toastr.info(commonLabels.NO_EXP_ADDED_NOTE);
        return;
      }
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let userId = session.userId;
      let isFirstPost = false;
      let request = [];
      let response;
      let getResponse;

      if (isExperience === "No") {
        if (experiencesList.length > 0) {
          toastr.info(commonLabels.DELETE_SAVE_EXP_NOTE);
          dispatch(hideLoader());
          return;
        } else {
          request.push({
            profileId: profileId,
            ...experienceInfoReqDTO,
            userId: userId,
            isDeleted: 0,
            isSubmittable: 1,
            isExperience: false,
          });
        }
      } else {
        for (let i = 0; i < experiencesList.length; i++) {
          request.push({
            profileId: profileId,
            ...experiencesList[i],
            //isDeleted: 0,
            userId: userId,
            isSubmittable: 1,
            isExperience: true,
          });
        }
        dispatch({
          payload: { experienceInfo: true },
          type: SET_A_SUBMITTABLE_FLG,
        });
      }
      if (profileId) {
        getResponse = await API.get(
          EXPERIENCE_INFORMATION + `/${userId}/${profileId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (getResponse != null) {
          dispatch(hideLoader());
        }
        if (isExperience === "No") {
          if (getResponse.data && getResponse.data[0]) {
            request[0].id = getResponse.data[0].id;
            isFirstPost = false;

            dispatch({
              payload: { experienceInfo: true },
              type: SET_A_SUBMITTABLE_FLG,
            });
          } else {
            request[0].id = "";
            isFirstPost = true;
          }
        } else {
          if (getResponse.data && getResponse.data.length > 0) {
            response = await API.patch(
              EXPERIENCE_INFORMATION + `/${userId}/${profileId}`,
              request,
              { headers: { Authorization: `Bearer ${token}` } }
            );
          } else {
            isFirstPost = true;
          }
        }
      } else {
        dispatch(hideLoader());
        isFirstPost = true;
      }
      if (isFirstPost) {
        response = await API.post(EXPERIENCE_INFORMATION, request, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response && response.data) {
          const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
          session.profileId = response.data[0].profileId;
          sessionStorage.setItem("session", JSON.stringify(session));
        }
        if (response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      if (response) {
        toastr.success(commonLabels.EXP_SAVED_NOTE);
        window.scrollTo(0, 0);
        dispatch(getExperienceInformation());

        dispatch({
          payload: response && response.data ? response.data : [],
          type: SET_EXPERIENCE_INFO,
        });
        let updatedFlgSubmittable =
          response.data.length > 0 ? response.data[0].isSubmittable : false;

        dispatch({
          payload: { experienceInfo: updatedFlgSubmittable },
          type: SET_A_SUBMITTABLE_FLG,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(commonLabels.EXP_INFO_INSERTION_ERR, errorMessage);
    }
  };
};

export const getExperienceInformation = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let profileId = session ? session.profileId : 1;
    if (!profileId) {
      dispatch(hideLoader());
      return;
    }
    let token = session.jwtResponse && session.jwtResponse.token;
    let userId = session.userId;
    let response = await API.get(
      EXPERIENCE_INFORMATION + `/${userId}/${profileId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    processExperienceInfoResponse(response, dispatch);
    if (response != null) {
      dispatch(hideLoader());
    }
  };
};
export const getDetailsForEditExperience = (experienceToBeEdited) => {

  return async (dispatch) => {
    dispatch({
      type: EDIT_EXPERIENCEINFO,
      payload: experienceToBeEdited,
    });
    dispatch({
      type: SET_EXPERIENCEINFO_EDIT_FLAG,
      payload: true,
    });
  };
};

export const clearEditExperienceInfo = (clearEditExperienceInfo) => {
  return async (dispatch) => {
    dispatch({
      type: EDIT_EXPERIENCEINFO,
      payload: clearEditExperienceInfo,
    });
    dispatch({
      type: SET_EXPERIENCEINFO_EDIT_FLAG,
      payload: false,
    });
  };
};

export const setProfileCreationDropdown = () => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      let response = await API.get(LOOKUP_OPTIONS, {
        params: { module: "profile_creation" },
      });
      let countryid = 88;
      let states_response = await API.get(STATES + `/${countryid}`);
      if (response != null || states_response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload:
          response && response.data ? response.data.lookupOptionDtoList : [],
        type: SET_PROFILE_CREATION_LOOKUPS,
      });
      dispatch({
        payload:
          states_response && states_response.data ? states_response.data : [],
        type: SET_STATES,
      });
      dispatch(hideLoader());
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }
    }
  };
};

export const setClass_Grade_Dropdown = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTIONS, {
        params: { module: "profile_creation" },
      });
      let countryid = 88;
      let states_response = await API.get(STATES + `/${countryid}`);
      if (response != null || states_response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload:
          response && response.data ? response.data.lookupOptionDtoList : [],
        type: SET_PROFILE_CREATION_LOOKUPS,
      });
      dispatch({
        payload:
          states_response && states_response.data ? states_response.data : [],
        type: SET_STATES,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getAllDisabilities = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "profile_creation",
          type: "disability_sub_category",
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data ? response.data : [],
        type: SET_ALL_DISABILITIES_DATA,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};
export const setDistrictDropdown = (statecode) => {
  return async (dispatch) => {
    try {
      let payload = [];
      if (statecode !== "") {
        let district_response = await API.get(DISTRICTS + `/29`);
        payload =
          district_response && district_response.data
            ? district_response.data
            : [];
      }
      dispatch({
        payload: payload,
        type: SET_DISTRICTS,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const setDistrictDropdownCorrespondenceAddress = (statecode) => {
  return async (dispatch) => {
    let payload = [];
    try {
      if (statecode !== "") {
        let district_response = await API.get(DISTRICTS + `/29`);
        payload =
          district_response && district_response.data
            ? district_response.data
            : [];
      }
      dispatch({
        payload: payload,
        type: SET_DISTRICTS_CORRESPONDENCE,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};
export const setTalukaDropdown = (districtcode) => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      let payload = [];
      if (districtcode !== "" && districtcode != null) {
        let taluka_response = await API.get(TALUKAS + `/${districtcode}`);
        payload =
          taluka_response && taluka_response.data ? taluka_response.data : [];
        if (taluka_response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      dispatch({
        payload: payload,
        type: SET_TALUKAS,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const setTalukaDropdownCorrespondenceAddress = (districtcode) => {
  return async (dispatch) => {
    try {

      dispatch(showLoader());
      let payload = [];
      if (districtcode !== "" && districtcode != null) {
        let taluka_response = await API.get(TALUKAS + `/${districtcode}`);
        payload =
          taluka_response && taluka_response.data ? taluka_response.data : [];
        if (taluka_response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      dispatch({
        payload: payload,
        type: SET_TALUKAS_CORRESPONDENCE,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const setVillageDropdown = (subdistrictcode) => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      let payload = [];
      if (subdistrictcode !== "" && subdistrictcode != null) {
        let village_response = await API.get(VILLAGES + `/${subdistrictcode}`);
        payload =
          village_response && village_response.data ? village_response.data : [];
        if (village_response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      dispatch({
        payload: payload,
        type: SET_VILLAGES,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const setVillageDropdownCorrespondenceAddress = (subdistrictcode) => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      let payload = [];
      if (subdistrictcode !== "" && subdistrictcode != null) {
        let village_response = await API.get(VILLAGES + `/${subdistrictcode}`);
        payload =
          village_response && village_response.data ? village_response.data : [];
        if (village_response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      dispatch({
        payload: payload,
        type: SET_VILLAGES_CORRESPONDENCE,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const setIssuingDistrictDropdown = () => {
  return async (dispatch) => {
    try {

      let district_response = await API.get(DISTRICTS + `/29`);
      dispatch({
        payload:
          district_response && district_response.data
            ? district_response.data
            : [],
        type: SET_ISSUING_DISTRICTS,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getPersonalInfoData = (isProfileId = 0, isAdmin = false) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      const profileId = isAdmin ? isProfileId : session.profileId;

      if (profileId) {
        let token = session.jwtResponse && session.jwtResponse.token;
        let personal_info = await API.get(
          PROFILE_CREATION + `/${profileId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        let responseOfPersonalInfo = personal_info.data;
        if (personal_info != null) {
          dispatch(hideLoader());
        }
        dispatch({
          payload: responseOfPersonalInfo,
          type: SET_PERSONAL_INFO,
        });
        dispatch({
          payload: { personalInfo: personal_info.data.isSubmittable },
          type: SET_A_SUBMITTABLE_FLG,
        });
      } else {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(
        commonLabels.ERROR_WHILE_FETCHING_PERSONAL_INFO,
        errorMessage
      );
    }
  };
};

export const savePersonalInfoData = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let userId = session ? session.userId : null;
    let isFirstPost = false;
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let reqBody = {
        ...data,
        userId: userId,
        profileId: profileId,
        isSubmittable: true,
      };
      let getResponse;
      let response;
      if (profileId) {
        getResponse = await API.get(
          PROFILE_CREATION + `/${session.profileId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (getResponse != null) {
          dispatch(hideLoader());
        }
        if (getResponse.data && getResponse.data.id) {
          reqBody.id = getResponse.data.id;
          response = await API.patch(PROFILE_CREATION, reqBody, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response != null) {
            dispatch(hideLoader());
          }
        } else {
          isFirstPost = true;
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
        isFirstPost = true;
      }
      if (isFirstPost) {
        response = await API.post(PROFILE_CREATION, reqBody, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response && response.data) {
          const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
          session.profileId = response.data.profileId;
          sessionStorage.setItem("session", JSON.stringify(session));
        }
        if (response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      if (response) {
        toastr.success(commonLabels.PERSONAL_INFO_SAVE_NOTE);
        window.scrollTo(0, 0);
        dispatch({
          payload: response.data,
          type: SET_PERSONAL_INFO,
        });
        dispatch({
          payload: { personalInfo: response.data.isSubmittable },
          type: SET_A_SUBMITTABLE_FLG,
        });
        dispatch(getdigilockerVerification());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }
    }
  };
};

export const setSportsDetails = (meritoriousSportsmanDtoList) => {
  return async (dispatch) => {
    dispatch({
      payload: meritoriousSportsmanDtoList,
      type: SET_SPORT_DETAILS_LIST,
    });
  };
};
export const clearSportForm = (flag) => {
  return async (dispatch) => {
    dispatch({
      payload: flag,
      type: CLEAR_SPORT_DTO,
    });
  };
};

export const editSportsDtails = (data, index) => {
  return async (dispatch) => {
    dispatch({
      payload: { sportsDetails: data, index },
      type: EDIT_SPORT_DETAILS_LIST,
    });
  };
};

export const otherInfoAction = (newaotherinfosDetails) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let userId = session ? session.userId : null;
    let isFirstPost = false;
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let request = {
        userId: userId,
        profileId: profileId,
        isSubmittable: 1,
        isProsecutionPending: newaotherinfosDetails.isProsecutionPending,
        isDispActionByBarcouncilInstitution:
          newaotherinfosDetails.isBarDisciplinaryActionInitiated,
        isDispActionByGovSemiGov:
          newaotherinfosDetails.isGovDisciplinaryActionInitiated,
        isCourtCaseFiled: newaotherinfosDetails.isCourtCasePending,
        isDebarredBlockListExam: newaotherinfosDetails.isDebarredForExamination,
        dbrNatureLookupId: newaotherinfosDetails.nature,
        dbrStartDate: newaotherinfosDetails.debarredStartDate,
        dbrEndDate: newaotherinfosDetails.debarredEndDate,
        activities: newaotherinfosDetails.activities && newaotherinfosDetails.activities.toUpperCase(),
        distinctionLeadershipPosition:
          newaotherinfosDetails.distinctionLeadershipPosition && newaotherinfosDetails.distinctionLeadershipPosition.toUpperCase(),
        extraCurricular: newaotherinfosDetails.extraCurricular && newaotherinfosDetails.extraCurricular.toUpperCase(),
      };
      let difference = dateDifferece(request.dbrStartDate, request.dbrEndDate);
      if (difference.firstDateWasLater) {
        toastr.error(commonLabels.FROM_DATE_CANT_GREATER_THAN_TO_DATE);
      } else {
        let response;
        let getResponse;
        if (profileId) {
          getResponse = await API.get(OTHER_INFORMATION + `/${profileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (getResponse.data && getResponse.data.id) {
            request.id = getResponse.data.id;
            response = await API.patch(OTHER_INFORMATION, request, {
              headers: { Authorization: `Bearer ${token}` },
            });
          } else {
            isFirstPost = true;
          }
          if (getResponse != null) {
            dispatch(hideLoader());
          }
        } else {
          dispatch(hideLoader());
          isFirstPost = true;
        }
        if (isFirstPost) {
          response = await API.post(OTHER_INFORMATION, request, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (response && response.data) {
            const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
            session.profileId = response.data.profileId;
            sessionStorage.setItem("session", JSON.stringify(session));
          }
          if (response != null) {
            dispatch(hideLoader());
          }
        } else {
          dispatch(hideLoader());
        }
        if (response) {
          let otherInformationResponse = {
            isProsecutionPending: response.data.isProsecutionPending,
            isBarDisciplinaryActionInitiated:
              response.data.isDispActionByBarcouncilInstitution,
            isGovDisciplinaryActionInitiated:
              response.data.isDispActionByGovSemiGov,
            isCourtCasePending: response.data.isCourtCaseFiled,
            isDebarredForExamination: response.data.isDebarredBlockListExam,
            nature: response.data.dbrNatureLookupId,
            debarredStartDate: response.data.dbrStartDate,
            debarredEndDate: response.data.dbrEndDate,
            otherInfoRowId: response.data.id,
            activities: response.data.activities,
            distinctionLeadershipPosition:
              response.data.distinctionLeadershipPosition,
            extraCurricular: response.data.extraCurricular,
            updatedAt: response.data.updatedAt,
            isLocked: response.data.isLocked,
          };
          toastr.success(commonLabels.OTHER_INFO_SAVE_NOTE);
          window.scrollTo(0, 0);
          dispatch({
            payload: otherInformationResponse,
            type: SET_OTHER_INFORMATION,
          });
          dispatch({
            payload: { otherInfo: response.data.isSubmittable },
            type: SET_A_SUBMITTABLE_FLG,
          });
        }
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }
    }
  };
}


export const getOtherInformation = () => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let profileId = session ? session.profileId : "";
      if (!profileId) {
        dispatch(hideLoader());
        return;
      }
      let token = session.jwtResponse && session.jwtResponse.token;
      let userId = session.userId;
      let response = await API.get(OTHER_INFORMATION + `/${profileId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        let debarredStartDate = response.data.dbrStartDate
          ? dayjs(response.data.dbrStartDate).toDate()
          : new Date();
        let debarredEndDate = response.data.dbrEndDate
          ? dayjs(response.data.dbrEndDate).toDate()
          : new Date();
        let otherInformationResponse = {
          isProsecutionPending: response.data.isProsecutionPending,
          isBarDisciplinaryActionInitiated:
            response.data.isDispActionByBarcouncilInstitution,
          isGovDisciplinaryActionInitiated:
            response.data.isDispActionByGovSemiGov,
          isCourtCasePending: response.data.isCourtCaseFiled,
          isDebarredForExamination: response.data.isDebarredBlockListExam,
          nature: response.data.dbrNatureLookupId,
          debarredStartDate: debarredStartDate,
          debarredEndDate: debarredEndDate,
          otherInfoRowId: response.data.id,
          activities: response.data.activities,
          distinctionLeadershipPosition:
            response.data.distinctionLeadershipPosition,
          extraCurricular: response.data.extraCurricular,
          updatedAt: response.data.updatedAt,
          isLocked: response.data.isLocked,
        };
        dispatch({
          payload: otherInformationResponse,
          type: SET_OTHER_INFORMATION,
        });
        dispatch({
          payload: { otherInfo: response.data.isSubmittable },
          type: SET_A_SUBMITTABLE_FLG,
        });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getAddressInformation = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
    let profileId = session ? session.profileId : "";
    if (!profileId) {
      dispatch(hideLoader());
      return;
    }
    let token = session.jwtResponse && session.jwtResponse.token;
    let userId = session.userId;
    let response;
    try {
      response = await API.get(ADDRESS_INFORMATION + `/${profileId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      processAddressInfoResponse(response, dispatch);
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
      }
    }
  };
};

export const getUploadedImageAndSignature = () => {
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let token = session.jwtResponse && session.jwtResponse.token;
  let profileId = session.profileId;
  let response;
  return async (dispatch) => {
    dispatch(showLoader());
    if (session.profileId) {
      try {
        response = await API.get(PHOTO_URL + `/${profileId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response != null) {
          dispatch(hideLoader());
        }

        if (response && response.data) {
          dispatch({
            payload: response && response.data ? response.data : [],
            type: SET_UPLOADED_PHOTO,
          });
          dispatch({
            payload: { uploadPhotoSign: response.data.isSubmittable },
            type: SET_A_SUBMITTABLE_FLG,
          });
        }
      } catch (error) {
        dispatch(hideLoader());
        toastr.error(
          commonLabels.UPLOADED_PHOTO_SIGNATURE_ERR_NOTE,
          error.response && error.response.data
            ? error.response.data.message
            : error.message
        );
      }
    }
  };
};

export const setShowModalValueFunction = (flag = false, photoMessage, livePhotoMessage) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: SET_SHOW_MODAL_VALUE,
        payload: { flag, photoMessage, livePhotoMessage }
      })
    } catch (error) {

    }
  }
}

export const PostLivePhoto = (data, flag, setLivephotoFlg, setPhotoFlg) => {
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let token = session.jwtResponse && session.jwtResponse.token;
  let profileId = session.profileId;
  let userId = session ? session.userId : null;
  let formData = new FormData();
  let isImageUpload = false;
  let livephotoFlg = null;
  let livePhotoResponse;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };


  if (data.livephoto) {
    formData.append("livephotoFile", data.livephoto);
    isImageUpload = true;
  }
  if (!data.livephoto) {
    isImageUpload = false;
  }
  if (profileId) {
    formData.append("profileId", profileId);
  }
  formData.append("userId", userId);
  formData.append("isSubmittable", 1);
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (flag === "post" && isImageUpload === true) {
        livePhotoResponse = await API.post(LIVE_PHOTO_DRAFT_API, formData, {
          headers: header,
        });
      } else if (flag === "patch" && isImageUpload === true) {
        livePhotoResponse = await API.patch(LIVE_PHOTO_DRAFT_API, formData, {
          headers: header,
        });
      } else {
        toastr.error(commonLabels.ADD_LIVE_PHOTO);
      }
      if (livePhotoResponse != null) {
        dispatch(hideLoader());
      }
      livephotoFlg = livePhotoResponse.data.isLivePhotoValidate;
      dispatch({
        type: SET_IS_LIVE_PHOTO_VALIDATE_VALUE,
        payload: livephotoFlg
      })


      if (livePhotoResponse) {
        if (flag === "post") {
          if ((livePhotoResponse.data.isLivePhotoValidate) || (livePhotoResponse.data.isLivePhotoValidate === null)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.message))
            return;
          }
          else if ((livePhotoResponse.data.isLivePhotoValidate)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.message))
            return;
          }
          else if ((livePhotoResponse.data.isLivePhotoValidate === false)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.livePhotoValidationMessage))
            return;
          }
          else if ((livePhotoResponse.data.isLivePhotoValidate === false)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.livePhotoValidationMessage))
            return;
          }

        } else {
          if ((livePhotoResponse.data.isLivePhotoValidate) || (livePhotoResponse.data.isLivePhotoValidate === null)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.message))
            return;
          }
          else if ((livePhotoResponse.data.isLivePhotoValidate)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.message))
            return;
          }
          else if ((livePhotoResponse.data.isLivePhotoValidate === false)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.livePhotoValidationMessage))
            return;
          }
          else if ((livePhotoResponse.data.isLivePhotoValidate === false)) {
            dispatch(setShowModalValueFunction(true, "", livePhotoResponse.data.livePhotoValidationMessage))
            return;
          }
        }
        dispatch(getUploadedImageAndSignature());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};
export const PostUploadPhotoAndSignature = (data, flag, setLivephotoFlg, setPhotoFlg) => {
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let token = session.jwtResponse && session.jwtResponse.token;
  let profileId = session.profileId;
  let userId = session ? session.userId : null;
  let formData = new FormData();
  let isImageUpload = false;

  let photoFlg = null;
  let livephotoFlg = null;

  // if (data.photo) {
  //   formData.append("photoFile", data.photo);
  //   isImageUpload = true;
  // }
  // formData.append("livephotoFile", "");
  // if (data.livephoto) {
  //   formData.append("livephotoFile", data.livephoto);
  //   isImageUpload = true;
  // }
  if (data.signature) {
    formData.append("signatureFile", data.signature);
    isImageUpload = true;
  }
  if (data.hinSignature) {
    formData.append("hinSignatureFile ", data.hinSignature);
    isImageUpload = true;
  }
  // if (!data.photo && !data.livephoto && !data.signature && !data.hindiSignature) {
  //   isImageUpload = false;
  // }
  if (!data.signature && !data.hindiSignature) {
    isImageUpload = false;
  }
  if (profileId) {
    formData.append("profileId", profileId);
  }
  formData.append("userId", userId);
  formData.append("isSubmittable", 1);

  // formData.append("isLivePhotoValidate", setLivephotoFlg);
  // formData.append("isProfilePhotoValidate", setPhotoFlg)

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (flag === "post" && isImageUpload === true) {
        response = await API.post(PHOTO_URL, formData, {
          headers: header,
        });
      } else if (flag === "patch" && isImageUpload === true) {
        response = await API.patch(PHOTO_URL, formData, {
          headers: header,
        });
      } else {
        toastr.error(commonLabels.ADD_PHOTO_OR_SIGNATURE);
      }
      if (response != null) {
        dispatch(hideLoader());
      }
      // photoFlg = response.data.isProfilePhotoValidate;
      // livephotoFlg = response.data.isLivePhotoValidate;

      // dispatch({
      //   type: SET_IS_PROFILE_PHOTO_VALIDATE_VALUE,
      //   payload: photoFlg
      // })
      // dispatch({
      //   type: SET_IS_LIVE_PHOTO_VALIDATE_VALUE,
      //   payload: livephotoFlg
      // })

      if (response) {
        // if (flag === "post") {

        //   if ((response.data.isLivePhotoValidate && response.data.isProfilePhotoValidate) || (response.data.isLivePhotoValidate === null && response.data.isProfilePhotoValidate === null)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_SUCCESS_MESSAGE, response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isProfilePhotoValidate === false && response.data.isLivePhotoValidate)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_ERROR_MESSAGE, response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isProfilePhotoValidate && response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_SUCCESS_MESSAGE, response.data.livePhotoValidationMessage))
        //     return;
        //   }
        //   else if ((response.data.isProfilePhotoValidate === false && response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_ERROR_MESSAGE, response.data.livePhotoValidationMessage))
        //     return;
        //   }

        // } else {
        //   if ((response.data.isLivePhotoValidate && response.data.isProfilePhotoValidate) || (response.data.isLivePhotoValidate === null && response.data.isProfilePhotoValidate === null)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_SUCCESS_MESSAGE, response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isProfilePhotoValidate === false && response.data.isLivePhotoValidate)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_ERROR_MESSAGE, response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isProfilePhotoValidate && response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_SUCCESS_MESSAGE, response.data.livePhotoValidationMessage))
        //     return;
        //   }
        //   else if ((response.data.isProfilePhotoValidate === false && response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, commonLabels.PROFILE_PHOTO_ERROR_MESSAGE, response.data.livePhotoValidationMessage))
        //     return;
        //   }
        // }

        // if (flag === "post") {

        //   if ((response.data.isLivePhotoValidate) || (response.data.isLivePhotoValidate === null)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isLivePhotoValidate)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.livePhotoValidationMessage))
        //     return;
        //   }
        //   else if ((response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.livePhotoValidationMessage))
        //     return;
        //   }

        // } else {
        //   if ((response.data.isLivePhotoValidate) || (response.data.isLivePhotoValidate === null)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isLivePhotoValidate)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.message))
        //     return;
        //   }
        //   else if ((response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.livePhotoValidationMessage))
        //     return;
        //   }
        //   else if ((response.data.isLivePhotoValidate === false)) {
        //     dispatch(setShowModalValueFunction(true, "", response.data.livePhotoValidationMessage))
        //     return;
        //   }
        // }
        toastr.success("Signature image uploaded successfully")
        dispatch(getUploadedImageAndSignature());
      }
    } catch (error) {
      dispatch(hideLoader());
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getAllQualificationTypes = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(QUALIFICATION_TYPES);
      if (response && response.data) {
        dispatch({
          type: SET_QUALIFICATION_TYPES,
          payload: response.data,
        });
      }
      if (response != null) {
        dispatch(hideLoader());
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_QUA_TYPES, errorMessage);
    }
  };
};

export const getQualificationNamesOfAType = (qualificationtypecode) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let response = await API.get(
        QUALIFICATION_NAME + `?qualificationtypecode=${qualificationtypecode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response != null) {
        dispatch(hideLoader());
      }

      if (response && response.data) {
        dispatch({
          type: SET_QUALIFICATION_NAMES,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_QUA_NAMES, errorMessage);
    }
  };
};

export const getStatesForAQualification = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let countryid = 88;
      let states_response = await API.get(STATES + `/${countryid}`);
      dispatch({
        payload:
          states_response && states_response.data ? states_response.data : [],
        type: SET_STATES,
      });
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error("Error while fetching Subjects for dropdown", errorMessage);
    }
  };
};

export const getSubjectsForAQualification = (qualificationNameCode) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (qualificationNameCode === "") {
        dispatch(hideLoader());
        return;
      }
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let response = await API.get(
        SUBJECTS + `?qualificationnamecode=${qualificationNameCode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response != null) {
        dispatch(hideLoader());
      }

      if (response && response.data) {
        dispatch({
          type: SET_SUBJECTS,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_SUBJECTS, errorMessage);
    }
  };
};

export const getUniversities = (statecode, qualificationnamecode = "NA") => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let response = await API.get(
        `${UNIVERSITIES}?statecode=${statecode}&qualificationnamecode=${(qualificationnamecode)}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        dispatch({
          type: SET_UNIVERSITIES,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(
        commonLabels.ERROR_WHILE_FETCHING_UNIVERSITIES,
        errorMessage
      );
    }
  };
};

const validateQualificationHierarchy = (toBeUpdatedQualificationList) => {
  if (
    toBeUpdatedQualificationList.length === 1 &&
    toBeUpdatedQualificationList[0].qualificationtypecode === "BSSC"
  ) {
    return true;
  } else {
    let qualificationMatch = toBeUpdatedQualificationList
      .filter((qualificaition) => {
        return (
          qualificaition.isDelete === false ||
          qualificaition.isDelete === undefined
        );
      })
      .findIndex((qualification) => {
        return mandatoryEducation.includes(qualification.qualificationtypecode);
      });
    return qualificationMatch === -1 ? false : true;
  }
};

export const addQualification = (
  qualificationToBeAdded,
  existingQualificationList
) => {
  if (qualificationToBeAdded.obtainedMarks * 1 > qualificationToBeAdded.totalMarks * 1) {
    toastr.warning("Obtained marks can not be greater than Total marks")
    return;
  }

  for (let i = 0; i < existingQualificationList.length; i++) {
    if ((qualificationToBeAdded.qualificationtypecode === "SSC" || qualificationToBeAdded.qualificationtypecode === "HSC" || qualificationToBeAdded.qualificationtypecode === "10th/Matric" || qualificationToBeAdded.qualificationtypecode === "12th/Intermediate") && (existingQualificationList[i].qualificationtypecode === qualificationToBeAdded.qualificationtypecode)) {
      toastr.warning(
        qualificationinformation.MATRIC_INTERMIDIATE_ALREADY_ADDED_WARNING
      );
      return;
    }
  }

  return async (dispatch) => {
    try {
      dispatch({
        type: ADD_QUALIFICATION,
        payload: [...existingQualificationList, qualificationToBeAdded],
      });


    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_ADDING_QUA_DETAILS, errorMessage);
    }
  };
};
export const addInternship = (
  internshipTobeAdded,
  existingInternshipList
) => {
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let profileId = session.profileId;

  let newAddedList = []


  let newInternship = {
    profileId: profileId,
    subject: internshipTobeAdded.qualificationtypecode,
    qualificationname: internshipTobeAdded.qualificationname,
    internshipFromDate: internshipTobeAdded.internshipFromDate.toISOString(),
    internshipToDate: internshipTobeAdded.internshipToDate.toISOString(),
    internshipCollege: internshipTobeAdded.internshipCollege,
    internshipCertificate: internshipTobeAdded.internshipCertificate,
    internshipIssueDate: internshipTobeAdded.internshipIssueDate.toISOString(),
    internshipIssuedBy: internshipTobeAdded.internshipIssuedBy,
  }
  return async (dispatch) => {
    try {
      dispatch({
        type: ADD_INTERNSHIP,
        payload: [...existingInternshipList, newInternship],
      });

      dispatch({
        type: ADD_INTERNSHIP_LIST,
        payload: [...newAddedList, newInternship],
      });

      let newInternshipList = [...newAddedList, newInternship]

      dispatch(saveInternshipList(newInternshipList))

      // toastr.info("Internship added save your changes");

    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_ADDING_QUA_DETAILS, errorMessage);
    }
  };
};

const cascadeDeleteIfConfirmed = (qualificationList, dispatch) => {
  try {
    let message = (
      <div className="confirmMessage">
        <p className="word-break">
          {qualificationinformation.QUALIFICATION_CASCADE_DELETE_MODAL_TITLE}
        </p>
        <p>
          {qualificationinformation.QUALIFICATION_CASCADE_DELETE_MODAL_BODY}
        </p>
      </div>
    );
    toastr.confirm(message, {
      onOk: async () => {
        let qualificaitionListForCascadeDelete = [];
        for (let i = 0; i < qualificationList.length; i++) {
          if (qualificationList[i].qualificationtypecode === "BSSC") {
            qualificaitionListForCascadeDelete.push(qualificationList[i]);
            continue;
          } else {
            let qualificaitionToBeDelted = qualificationList[i];
            qualificaitionToBeDelted.isDelete = true;
            qualificaitionListForCascadeDelete.push(qualificaitionToBeDelted);
          }
        }
        toastr.info(commonLabels.QUA_DELETED_NOTE);
        dispatch({
          type: ADD_QUALIFICATION,
          payload: qualificaitionListForCascadeDelete,
        });
        dispatch({
          type: SET_CURRENT_EDIT_QUALIFICATION_INDEX,
          payload: -1,
        });
        dispatch({
          type: SET_SELECTED_QUALIFICATION_TYPE,
          payload: "Select",
        });
      },
    });
  } catch (error) {
    toastr.error(commonLabels.ERR_WHILE_DELETING_QUA, error);
  }
};

export const deleteQualification = (
  qualificationRowIndex,
  existingQualificationList
) => {
  return async (dispatch) => {
    try {
      let toBeUpdatedQualificationList = existingQualificationList;
      toBeUpdatedQualificationList[qualificationRowIndex].isDelete = true;
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      if (!validateQualificationHierarchy(toBeUpdatedQualificationList)) {
        dispatch(getQualificationDetails());
        cascadeDeleteIfConfirmed(
          toBeUpdatedQualificationList,
          token,
          profileId,
          dispatch
        );
        return;
      }
      toastr.info(commonLabels.QUA_DETAILS_DELETED_NOTE);
      dispatch({
        type: ADD_QUALIFICATION,
        payload: toBeUpdatedQualificationList,
      });
      dispatch({
        type: SET_CURRENT_EDIT_QUALIFICATION_INDEX,
        payload: -1,
      });
      dispatch({
        type: SET_SELECTED_QUALIFICATION_TYPE,
        payload: "Select",
      });
    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_DELETING_QUA_DETAILS, errorMessage);
    }
  };
};

export const getDetailsForEditQualification = (qualificationToBeEdited) => {

  return async (dispatch) => {
    dispatch({
      type: EDIT_QUALIFICATION,
      payload: qualificationToBeEdited,
    });
    let qualificationtypecodeEdit =
      qualificationToBeEdited.qualificationtypecode;
    let qualificationnamecodeEdit =
      qualificationToBeEdited.qualificationnamecode;
    let stateCodeEdit = qualificationToBeEdited.statecode;
    dispatch({
      type: SET_SELECTED_QUALIFICATION_TYPE,
      payload: qualificationtypecodeEdit,
    });
    dispatch({
      type: IS_QUALIFICATION_TYPE_CHANGED_BY_DROPDOWN,
      payload: false,
    });
    if (qualificationtypecodeEdit !== "Ph.D Guide") {
      dispatch(getQualificationNamesOfAType(qualificationtypecodeEdit));
    }
    if (qualificationnamecodeEdit) {
      dispatch(getSubjectsForAQualification(qualificationnamecodeEdit));
    }
    if (stateCodeEdit) {
      if (["SSC", "HSC", "12th/Intermediate", "10th/Matric", "AMIE"].includes(qualificationnamecodeEdit)) {
        dispatch(getUniversities(stateCodeEdit, qualificationnamecodeEdit));
      } else {
        dispatch(getUniversities(stateCodeEdit));
      }
    }
  };
};
export const getDetailsForEditInternship = (qualificationToBeEdited) => {

  return async (dispatch) => {
    dispatch({
      type: EDIT_INTERNSHIP,
      payload: qualificationToBeEdited[0],
    });
    let qualificationtypecodeEdit =
      qualificationToBeEdited[0].subject;
    let internshipQualificationnameEdit =
      qualificationToBeEdited[0].qualificationname;
    dispatch({
      type: SET_SELECTED_QUALIFICATION_TYPE,
      payload: qualificationtypecodeEdit,
    });
    dispatch({
      type: IS_QUALIFICATION_TYPE_CHANGED_BY_DROPDOWN,
      payload: false,
    });
  };
};

export const editQualification = (
  qualificationToBeEdited,
  existingQualificationList,
  currentEditQualificationIndex
) => {


  if (qualificationToBeEdited.obtainedMarks * 1 > qualificationToBeEdited.totalMarks * 1) {
    toastr.warning("Obtained marks can not be greater than Total marks")
    return;
  }

  return async (dispatch) => {
    try {
      if (currentEditQualificationIndex !== -1) {
        existingQualificationList[currentEditQualificationIndex] =
          qualificationToBeEdited;
        toastr.info(commonLabels.REC_UPDATED_NOTE);
        dispatch({
          type: SET_CURRENT_EDIT_QUALIFICATION_INDEX,
          payload: -1,
        });

        dispatch({
          type: ADD_QUALIFICATION,
          payload: existingQualificationList,
        });

        dispatch({
          type: EDIT_QUALIFICATION_DONE_RESET,
        });

        dispatch(
          toggleAndSetEditing(currentEditQualificationIndex, false, true)
        );
      }
    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_EDITING_QUA_DETAILS, errorMessage);
    }
  };
};
export const editInternship = (
  internShipToBeEdited,
  existingInternshipList,
  currentEditInternshipId
) => {

  return async (dispatch) => {
    try {
      if (currentEditInternshipId !== -1) {
        existingInternshipList.map((ele) =>
          ele.id === currentEditInternshipId ? { ...ele, ...internShipToBeEdited } : ele
        );

        toastr.success(commonLabels.INTERNSHIP_UPDATED_NOTE);

        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let profileId = session.profileId;

        let internshipRequestbody = [{
          id: currentEditInternshipId,
          qualificationname: internShipToBeEdited.qualificationname,
          internshipCertificate: internShipToBeEdited.internshipCertificate,
          internshipCollege: internShipToBeEdited.internshipCollege,
          internshipFromDate: internShipToBeEdited.internshipFromDate,
          internshipToDate: internShipToBeEdited.internshipToDate,
          internshipIssuedBy: internShipToBeEdited.internshipIssuedBy,
          internshipIssueDate: internShipToBeEdited.internshipIssueDate,
          isDelete: false,
          isLocked: internShipToBeEdited.isLocked,
        }
        ]
        let internResponse = await API.patch(
          INTERNSHIP + `/${profileId}`,
          internshipRequestbody,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // window.location.reload();

        dispatch(getQualificationDetails())

        dispatch({
          type: SET_TOGGLE_EDIT_MODE,
          payload: true,
        })

        dispatch({
          type: SET_CURRENT_EDIT_INTERNSHIP_INDEX,
          payload: -1,
        });

        dispatch({
          type: ADD_INTERNSHIP,
          payload: existingInternshipList,
        });

        dispatch({
          type: SET_SELECTED_QUALIFICATION_TYPE,
          payload: "Select",
        });

        dispatch(
          toggleAndSetEditing(currentEditInternshipId, false, true)
        );
      }
    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_EDITING_INTERN_DETAILS, errorMessage);
    }
  };
};

export const deleteInternship = (
  currentEditInternshipId,
  existingInternshipList,
) => {

  return async (dispatch) => {
    try {
      if (currentEditInternshipId !== -1) {
        const internShipToBeEdited = existingInternshipList.filter(
          (ele) => ele.id === currentEditInternshipId
        );

        const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
        let token = session.jwtResponse && session.jwtResponse.token;
        let profileId = session.profileId;

        let internshipRequestbody = [{
          id: currentEditInternshipId,
          qualificationname: internShipToBeEdited[0].qualificationname,
          internshipCertificate: internShipToBeEdited[0].internshipCertificate,
          internshipCollege: internShipToBeEdited[0].internshipCollege,
          internshipFromDate: internShipToBeEdited[0].internshipFromDate,
          internshipToDate: internShipToBeEdited[0].internshipToDate,
          internshipIssuedBy: internShipToBeEdited[0].internshipIssuedBy,
          internshipIssueDate: internShipToBeEdited[0].internshipIssueDate,
          isDelete: true,
        }
        ]

        let internResponse = await API.patch(
          INTERNSHIP + `/${profileId}`,
          internshipRequestbody,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        toastr.success(commonLabels.REC_UPDATED_NOTE);

        // window.location.reload();
        dispatch(getQualificationDetails())

        dispatch({
          type: SET_TOGGLE_EDIT_MODE,
          payload: true,
        })

        dispatch({
          type: SET_CURRENT_EDIT_INTERNSHIP_INDEX,
          payload: -1,
        });

        dispatch({
          type: ADD_INTERNSHIP,
          payload: existingInternshipList,
        });

        dispatch({
          type: EDIT_QUALIFICATION_DONE_RESET,
        });

        dispatch(
          toggleAndSetEditing(currentEditInternshipId, false, true)
        );
      }
    } catch (error) {
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_DELETING_INTERNSHIP_DETAILS, errorMessage);
    }
  };
};

export const saveInternshipList = (updatedInternshipsList) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (updatedInternshipsList.length === 0) {
        dispatch(hideLoader());
        toastr.info(commonLabels.NO_QUA_ADDED_NOTE);
        return;
      }

      let toBeUpdatedInternshipList = updatedInternshipsList;

      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      if (!session) {
        toastr.error("Session expired. Please log in again.");
        dispatch(hideLoader());
        return;
      }

      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      if (!profileId) {
        toastr.error("Profile ID is missing. Please log in again.");
        dispatch(hideLoader());
        return;
      }

      let userId = session.userId;
      let isFirstInterPost = true;
      let internshipRequest = []
      internshipRequest = updatedInternshipsList
        .filter((internship) => internship.subject === "Internship")
        .map((internship) => ({

          profileId: profileId,
          subject: internship.subject,
          qualificationname: internship.qualificationname,
          internshipFromDate: new Date(internship.internshipFromDate).toISOString(),
          internshipToDate: new Date(internship.internshipToDate).toISOString(),
          internshipCollege: internship.internshipCollege,
          internshipCertificate: internship.internshipCertificate,
          internshipIssueDate: new Date(internship.internshipIssueDate).toISOString(),
          internshipIssuedBy: internship.internshipIssuedBy,
          isDelete: false,
          isLocked: internship.isLocked
        }));

      let internResponse;
      let getIntershipResponse;


      if (profileId && internshipRequest.length > 0) {
        getIntershipResponse = await API.get(
          INTERNSHIP + `/${profileId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        dispatch({
          type: SET_INTERNSHIP_LIST,
          payload: getIntershipResponse.data,
        })

        if (getIntershipResponse != null) {
          dispatch(hideLoader());
        }
        if (getIntershipResponse.data === null) {
          isFirstInterPost = true;
        }

        // if (getIntershipResponse.data && getIntershipResponse.data.length > 0) {
        //   internResponse = await API.patch(
        //     INTERNSHIP + `/${profileId}`,
        //     internshipRequest,
        //     { headers: { Authorization: `Bearer ${token}` } }
        //   );
        //   // window.location.reload();
        // } else {
        //   isFirstInterPost = true;
        // }


      } else {
        dispatch(hideLoader());
        // isFirstInterPost = true;
      }



      if (isFirstInterPost) {
        internResponse = await API.post(INTERNSHIP, internshipRequest, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (internResponse?.data?.length > 0) {
          session.profileId = internResponse.data[0].profileId;
          sessionStorage.setItem("session", JSON.stringify(session));
        }

        if (internResponse != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
      if (internResponse) {
        toastr.success(commonLabels.INTERNSHIP_INFO_SAVED_NOTE);
        window.scrollTo(0, 0);
        dispatch(verifyQualificationDigilocker());
        dispatch(getQualificationDetails());
        dispatch({
          type: SET_CURRENT_EDIT_QUALIFICATION_INDEX,
          payload: -1,
        });
        dispatch({
          type: SET_SELECTED_QUALIFICATION_TYPE,
          payload: "Select",
        });
      }
      dispatch(toggleAndSetEditing(null, false, false));
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(errorMessage);
    }
  };
};

export const saveQualificationsList = (qualificationsList) => {

  return async (dispatch) => {
    dispatch(showLoader());
    try {
      if (qualificationsList.length === 0) {
        dispatch(hideLoader());
        toastr.info(commonLabels.NO_QUA_ADDED_NOTE);
        return;
      }

      let toBeUpdatedQualificationList = qualificationsList;
      if (!validateQualificationHierarchy(toBeUpdatedQualificationList)) {
        dispatch(hideLoader());
        toastr.warning(
          qualificationinformation.QUALIFICATION_CASCADE_DELETE_MODAL_TITLE
        );
        return;
      }
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let userId = session.userId;
      let isFirstPost = false;
      let request = [];
      for (let i = 0; i < qualificationsList.length; i++) {
        request.push({
          profileId: profileId,
          ...qualificationsList[i],
          userId: userId,
          isSubmittable: 1,
          // isDelete: 0,
          // isDeleted: 0,
        });

      }
      let response;
      let getResponse;

      if (profileId) {
        getResponse = await API.get(
          QUALIFICATION_INFORMATION + `/${profileId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (getResponse.data === null) {
          isFirstPost = true;
        }

        if (getResponse != null) {
          dispatch(hideLoader());
        }

        if (getResponse.data && getResponse.data.length > 0) {
          response = await API.patch(
            QUALIFICATION_INFORMATION + `/${profileId}`,
            request,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          // window.location.reload();
        } else {
          isFirstPost = true;
        }
      } else {
        dispatch(hideLoader());
        isFirstPost = true;
      }
      if (isFirstPost) {
        response = await API.post(QUALIFICATION_INFORMATION, request, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response && response.data) {
          const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
          session.profileId = response.data[0].profileId;
          sessionStorage.setItem("session", JSON.stringify(session));
          // window.location.reload();
        }
        if (response != null) {
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }


      if (response) {
        toastr.success(commonLabels.QUA_INFO_SAVED_NOTE);
        window.scrollTo(0, 0);
        dispatch(verifyQualificationDigilocker());
        dispatch(getQualificationDetails());
        dispatch({
          type: SET_CURRENT_EDIT_QUALIFICATION_INDEX,
          payload: -1,
        });
        dispatch({
          type: SET_SELECTED_QUALIFICATION_TYPE,
          payload: "Select",
        });
      }

      dispatch(toggleAndSetEditing(null, false, false));
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(errorMessage);
    }
  };
};

export const getQualificationDetails = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      if (!profileId) {
        dispatch(hideLoader());
        return;
      }
      let response = await API.get(
        QUALIFICATION_INFORMATION + `/${profileId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      let getIntershipResponse = await API.get(
        INTERNSHIP + `/${profileId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      dispatch({
        type: SET_INTERNSHIP_LIST,
        payload: getIntershipResponse.data,
      })

      if (getIntershipResponse != null) {
        dispatch(hideLoader());
      }
      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {
        processQualificationInfoResponse(response, dispatch);
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_QUA_DETAILS, errorMessage);
    }
  };
};

export const getDisplayableQualificationList = (crudQualificationsList) => {
  return async (dispatch) => {
    dispatch(showLoader());

    for (let i = 0; i < crudQualificationsList.length; i++) {
      if ((crudQualificationsList[i].isPublicationFirstAuthor == "" || crudQualificationsList[i].isPublicationFirstAuthor == null)) {
        crudQualificationsList[i].isPublicationFirstAuthor = false;
      }
      if ((crudQualificationsList[i].isImpactIndex20OrMore == "" || crudQualificationsList[i].isImpactIndex20OrMore == null)) {
        crudQualificationsList[i].isImpactIndex20OrMore = false;
      }
      if ((crudQualificationsList[i].yearOfPassing == "" || crudQualificationsList[i].yearOfPassing == null)) {
        crudQualificationsList[i].yearOfPassing = "0";
      }
      if ((crudQualificationsList[i].seatNumber == "" || crudQualificationsList[i].seatNumber == null)) {
        crudQualificationsList[i].seatNumber = "NA";
      }
    }

    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId;
      let response = await API.post(
        GET_DISPLAYABLE_QUALIFICATION_LIST,
        crudQualificationsList,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response != null) {
        dispatch(hideLoader());
      }

      if (response && response.data) {

        dispatch({
          type: SET_DISPLAYABLE_QUALIFICATION_LIST,
          payload: response.data,
        });
      }


    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_QUA_TABLE, errorMessage);
    }
  };
};

export const getInternshipDetails = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      if (!profileId) {
        dispatch(hideLoader());
        return;
      }
      let response = await API.get(
        INTERNSHIP + `/${profileId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response != null) {
        dispatch(hideLoader());
      }
      if (response && response.data) {


        processQualificationInfoResponse(response, dispatch);
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_INTER_DETAILS, errorMessage);
    }
  };
};

export const setImagesrc = (imageSrc) => {
  return async (dispatch) => {
    dispatch({
      payload: imageSrc,
      type: SET_IMAGE_SRC,
    });
  };
};

export const setLiveImagesrc = (imageSrc) => {
  return async (dispatch) => {
    dispatch({
      payload: imageSrc,
      type: SET_LIVEIMAGE_SRC,
    });
  };
};

export const setSignaturesrc = (signatureSrc) => {
  return async (dispatch) => {
    dispatch({
      payload: signatureSrc,
      type: SET_SIGNATURE_SRC,
    });
  };
};

export const setHindiSignaturesrc = (hindiSignatureSrc) => {
  return async (dispatch) => {
    dispatch({
      payload: hindiSignatureSrc,
      type: SET_HINDI_SIGNATURE_SRC,
    });
  };
};

export const cropperImageURL = (copperImage) => {
  return function (dispatch) {
    dispatch({
      payload: copperImage.cropImage,
      type: SET_CROPE_IMAGE_SRC,
    });
  };
};

export const cropperLiveImageURL = (copperImage) => {
  return function (dispatch) {
    dispatch({
      payload: copperImage.cropLiveImage,
      type: SET_CROPE_LIVEIMAGE_SRC,
    });
  };
};
export const setCropperSignaturesrc = (signatureSrc) => {
  return async (dispatch) => {
    dispatch({
      payload: signatureSrc,
      type: SET_CROP_SIGNATURE_SRC,
    });
  };
};

export const showImageSignatureFlag = (isImageShow, isLiveImageShow, isSignatureShow) => {
  let obj = {
    isImageShow: isImageShow,
    isLiveImageShow: isLiveImageShow,
    isSignatureShow: isSignatureShow,
  };
  return async (dispatch) => {
    dispatch({
      payload: obj,
      type: SET_IMAGE_SIGNATURE_FLAG,
    });
  };
};

export const getProfileStatus = () => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let profileStatus = false;
      if (!profileId) {
        dispatch(hideLoader());
        return profileStatus;
      }
      let response = await API.get(PROFILE + `/${profileId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response != null) {
        dispatch(hideLoader());
      }

      profileStatus = response && response.data ? response.data : false;
      dispatch({
        payload: profileStatus,
        type: SET_PROFILE_STATUS,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const submitProfile = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;
      let userId = session.userId;
      let response = await API.patch(
        PROFILE + `/${userId}/${profileId}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response != null) {
        dispatch(hideLoader());
      }
      let profileStatus = false;
      if (response && response.data) {
        profileStatus = response.data.isLocked;
        toastr.success(commonLabels.CANDIDATE_PROFILE_NOTE);
        window.scrollTo(0, 0);
      } else {
        profileStatus = false;
      }

      dispatch({
        payload: false,
        type: SET_UPDATE_PROFILE_DONE,
      });
      dispatch({
        payload: profileStatus,
        type: SET_PROFILE_STATUS,
      });
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error(
        commonLabels.ERR_WHILE_SUBMITTING_CANDIDATE_PROFILE,
        errorMessage
      );
    }
  };
};

export const disableAllSaveAfterSubmit = (flag) => {
  return function (dispatch) {
    dispatch({
      payload: flag,
      type: SET_DISABLE_ALL_TAB_SAVE,
    });
  };
};

export const setExperienceTableList = (data) => {
  return function (dispatch) {
    dispatch({
      payload: data,
      type: SET_EXPERIENCE_TABLE_LIST,
    });
  };
};

export const getAdditionResEnvData = () => {
  return async (dispatch) => {
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let response = await API.get(GET_ADDITIONAL_RES_ENV, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response != null) {
        dispatch({
          payload: response.data,
          type: SET_ADDITIONAL_RES_ENV_DATA,
        });
      }
    } catch (error) {
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error("Error :", errorMessage);
    }
  };
};

export const getPublicationTypeData = (qualificationtypecode) => {
  return async (dispatch) => {
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let response = await API.get(
        GET_PUBLICATION_TYPE_DATA +
        `?qualificationtypecode=${qualificationtypecode}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response != null) {
        dispatch({
          payload: response.data,
          type: SET_PUBLICATION_TYPE_DATA,
        });
      }
    } catch (error) {
      let errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      toastr.error("Error :", errorMessage);
    }
  };
};

export const getAllNameOfIndexingBodies = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "profile_creation",
          type: "publication_indexing_bodies",
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data ? response.data : [],
        type: GET_NAME_OF_INDEXING_BODIES,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getAllPublicationArticleTypes = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "profile_creation",
          type: "publication_article_type",
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data ? response.data : [],
        type: GET_TYPE_OF_ARTICLES,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getAllJobDesignationDetails = () => {
  return async (dispatch) => {
    try {

      dispatch(showLoader());
      let response = await API.get(LOOKUP_OPTION, {
        params: {
          module: "profile_creation",
          type: "designation",
        },
      });
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload:
          response && response.data ? response.data.lookupOptionDtoList : [],
        type: GET_ALL_JOB_DESIGNATION_LIST,
      });
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getAllStatesList = () => {
  return async (dispatch) => {
    try {
      dispatch(showLoader());
      let countryid = 88;
      let states_response = await API.get(STATES + `/${countryid}`);
      if (states_response != null) {
        dispatch({
          payload:
            states_response && states_response.data ? states_response.data : [],
          type: SET_STATES,
        });
        dispatch(hideLoader());
      }
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getPersonalInfoDigilockerStatus = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let profileId = session.profileId;
      let response = await API.get(
        GET_PERSONAL_DIGILOCKER_STATUS + `/${profileId}`
      );
      if (response != null) {
        dispatch(hideLoader());
      }
      dispatch({
        payload: response && response.data ? response.data : [],
        type: SET_PERSONAL_DIGILOCKER_STATUS,
      });
      sessionStorage.setItem("digilocker_statuses", response.data);
    } catch (error) {
      if (error.response && error.response.data) {
        toastr.error(error.response.data.message);
      } else {
        toastr.error(error.message);
        throw new error(error.message);
      }
    }
  };
};

export const getYearList = () => {
  const year = new Date().getFullYear();
  const startYear = 1960; // Start year is 1960
  return Array.from(new Array(year - startYear + 1), (v, i) => (
    <option key={i} value={year - i}>
      {year - i}
    </option>
  ));
};

export const getdigilockerVerification = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
      let token = session.jwtResponse && session.jwtResponse.token;
      let profileId = session.profileId;

      let userId = session.userId;
      let response = "";
      if (profileId && userId && sessionStorage.getItem("digilocker_statuses") && sessionStorage.getItem("digilocker_accesstoken")) {
        response = await API.post(
          GET_DIGILOCKER_VERIFY_DETAILS,
          {
            "profileId": profileId,
            "userId": userId,
            "digiLockerStatus": sessionStorage.getItem("digilocker_statuses"),
            "digiLockerToken": sessionStorage.getItem("digilocker_accesstoken")
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      }

      if (response != null) {
        dispatch(hideLoader());
      }

      if (response && response.data) {
        dispatch({
          type: SET_DIGILOCKER_ACCESSTOKEN_DATA,
          payload: response.data,
        });
      }
    } catch (error) {
      dispatch(hideLoader());
      let errorMessage = "";
      if (error.response && error.response.data) {
        errorMessage = error.response.data.message;
      } else {
        errorMessage = error.message;
      }
      toastr.error(commonLabels.ERROR_WHILE_FETCHING_QUA_TABLE, errorMessage);
    }
  };
};

export const getFormattedLastUpdatedDate = (date) => {
  return (date === "Invalid Date") ? "No new updation" : date;
}